import { css } from '@emotion/core'

export const styles = {
  container: css`
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
  `,

  content: css`
    width: 42vw;
    min-width: 700px;
    min-height: calc(100vh - 70px - 197px);

    padding: 25px 10px 10px 10px;
  `,

  header: {
    container: css`
      height: 34px;
      margin-bottom: 14px;
      margin-top: 15px;

      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05), 0 10px 7px rgba(0, 0, 0, 0.01);
      background: rgb(58, 137, 196);
      border-radius: 5px;

      display: flex;
      user-select: none;
      cursor: pointer;
    `,

    title: css`
      flex: 1;

      display: flex;
      align-items: center;
      justify-content: center;

      color: white;
      text-transform: uppercase;
      font-size: 13px;
      font-weight: 600;
    `,

    icon: css`
      width: 34px;

      display: flex;
      align-items: center;
      justify-content: center;

      opacity: 0.65;
      transition: 300ms;

      &:hover {
        opacity: 0.9;
        transition: 100ms;
      }
    `,
  },

  section: {
    wrapper: css`
      margin-bottom: 15px;
    `,

    expanded: css`
      margin-bottom: 25px;
    `,

    container: css`
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05), 0 10px 7px rgba(0, 0, 0, 0.005);
      background: white;
      border-radius: 5px;

      padding: 10px;
      margin-bottom: 10px;

      display: flex;
      flex-direction: row;
    `,

    side: css`
      flex: 1;
      padding: 10px;

      display: flex;
      flex-direction: column;
    `,

    containerPadded: css`
      padding: 0px;
    `,

    sidePadded: css`
      padding: 20px;
    `,
  },

  button: css`
    float: right;

    width: 200px;
    height: 36px;
    margin: 20px 0 40px 0;

    padding-top: 2px;
    background: rgb(58, 137, 196);
    border-radius: 5px;
    border: none;

    color: white;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    font-family: 'Open Sans', sans-serif;

    cursor: pointer;

    &:disabled {
      opacity: 0.75;
    }

    &:focus {
      outline: none;
    }

    &:active {
      box-shadow: 0 0 0 3px rgba(58, 137, 196, 0.5);
    }
  `,
}
